import {Combobox} from 'evergreen-ui';
import React, {useCallback} from 'react';
import {BehaviorSubject} from 'rxjs';
import {useObservable} from 'rxsupport';
import {QueryableReferralStatus} from '../hook/useReferralQueryForProvider$';


const ReferralStatusLabels = {
    'AVAILABLE': 'Available Referrals',
    'ACCEPTED': 'Accepted Referrals',
};
const allValues = Object.keys(ReferralStatusLabels);
const toLabel = (item: QueryableReferralStatus) => ReferralStatusLabels[item]


type ReferralStatusComboBoxProps = {
    statusFilter$: BehaviorSubject<QueryableReferralStatus>,
}
export const ReferralStatusComboBox = ({statusFilter$}: ReferralStatusComboBoxProps) => {
    const currentStatus = useObservable(statusFilter$, 'AVAILABLE');

    const onChange = useCallback((selected: QueryableReferralStatus) => {
        statusFilter$.next(selected);
    }, [statusFilter$]);

    return (
        <Combobox
            marginRight={8}
            openOnFocus
            selectedItem={currentStatus}
            items={allValues}
            itemToString={toLabel}
            onChange={onChange}
            height={40}
            buttonProps={{appearance: 'minimal', intent: 'none'}}
            inputProps={{
                className: 'portal-ev-combobox',
                disabled: true,
            }}
            className='rounded-md border-2 portal-ev-combobox'
        />
    );
}
